const Routes = {
  CampaignManager: 'CampaignManager',
};

export { Routes };
